module.exports = __webpack_public_path__ + "static/media/devadath_ks.0000ba78.jpg";